import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { pricingTiers } from '../data/pricing';

const Pricing = () => {
  return (
    <section id="tarifs" className="py-24 bg-white relative">
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_center,rgba(30,64,175,0.05),transparent_70%)]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Tarifs <span className="text-blue-900">indicatifs</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Chaque projet est unique : ces fourchettes servent de base pour cadrer une première discussion.
            Un devis précis est établi après analyse de votre besoin.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {pricingTiers.map(tier => (
            <div
              key={tier.id}
              className="relative flex flex-col rounded-2xl border border-gray-200 bg-white shadow-sm hover:shadow-lg transition overflow-hidden"
            >
              <div className="p-6 flex-1 flex flex-col">
                <div className="mb-4">
                  <h3 className="text-lg font-semibold text-gray-900">
                    {tier.title}
                  </h3>
                  <p className="text-sm text-gray-600 leading-relaxed">{tier.short}</p>
                </div>
                <div className="mb-5">
                  <div className="text-2xl font-bold text-blue-900">{tier.price}</div>
                  {tier.unit && <div className="text-xs uppercase tracking-wide text-gray-500">{tier.unit}</div>}
                  {tier.idealFor && <div className="mt-2 text-xs text-gray-500">{tier.idealFor}</div>}
                </div>
                <ul className="space-y-2 mb-6 text-sm">
                  {tier.features.map((f,i) => (
                    <li key={i} className="flex items-start gap-2">
                      <CheckCircle2 className="w-4 h-4 text-blue-800 mt-0.5" />
                      <span className="text-gray-700 leading-snug">{f}</span>
                    </li>
                  ))}
                </ul>
                {tier.note && <div className="text-xs text-gray-500 mt-auto border-t pt-3 leading-relaxed">{tier.note}</div>}
              </div>
              <div className="px-6 pb-6">
                {tier.stripeLink ? (
                  <a
                    href={tier.stripeLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="block text-center w-full rounded-lg bg-blue-900 text-white py-3 font-semibold text-sm hover:bg-blue-800 transition"
                    aria-label={`Payer en ligne ${tier.title}`}
                  >
                    Payer en ligne
                  </a>
                ) : (
                  <button
                    onClick={() => {
                      const el = document.getElementById('contact');
                      if (el) el.scrollIntoView({ behavior: 'smooth' });
                    }}
                    className="w-full rounded-lg bg-blue-900 text-white py-3 font-semibold text-sm hover:bg-blue-800 transition"
                  >
                    Demander un devis
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 max-w-3xl mx-auto text-center text-sm text-gray-500 leading-relaxed">
          Ces tarifs sont donnés à titre indicatif et peuvent varier selon : la complexité technique, les contraintes réglementaires,
          la surface, le nombre d'intervenants, la durée et les aléas potentiels. Une proposition détaillée et personnalisée
          vous est transmise après qualification de votre projet.
        </div>
      </div>
    </section>
  );
};

export default Pricing;
